/**
 * What the Remote Desktop page shows instead of its tables, or null when the tables have data.
 * - `no-access`: the caller's policies name no pool for listing hosts or workspaces, so there is
 *   nothing to ask for (the query's pool is non-null; sending null only earns a GraphQL error).
 * - `error`: the list query failed; Apollo Client 4 reports a GraphQL error as `result.error`
 *   with no data rather than throwing, so it must be read here, not left to catchError.
 * - `loading`: no answer yet.
 */
export type CrdListState = {kind: 'no-access'} | {kind: 'error', message: string} | {kind: 'loading'} | null;

export function crdListState(pools: {hosts: string | null, workspaces: string | null},
                             result: {data?: unknown, error?: {message?: string} | null} | undefined): CrdListState {
  if (!pools.hosts || !pools.workspaces) {
    return {kind: 'no-access'};
  }
  if (result?.data) {
    return null;
  }
  if (result?.error) {
    return {kind: 'error', message: result.error.message || 'Unknown error'};
  }
  return {kind: 'loading'};
}
